import React from 'react'
import cn from 'clsx'
import styles from './index.module.css'

type Props = {
  caption: React.ReactNode
  media?: React.ReactNode
  title: React.ReactNode
}

/**
 * A media item component that displays content with an optional media thumbnail.
 * Commonly used for displaying media files, tracks, or other content with visual representation.
 *
 * @param caption - The secondary text or description to display below the title
 * @param media - Optional media element (image, icon, etc.) to display alongside the content
 * @param title - The primary title or name of the media item
 * @returns A media item layout with optional media thumbnail and title/caption text
 */
const MediaItem = ({
  caption,
  media,
  title,
}: Props): React.ReactElement<'div'> => {
  return (
    <div className={styles.mediaItem}>
      {media && <div className={styles.mediaItemMedia}>{media}</div>}
      <div className={styles.mediaItemContent}>
        <div
          className={cn('overflow-ellipsis', styles.mediaItemTitle)}
          title={typeof title === 'string' ? title : undefined}
        >
          {title}
        </div>
        <div className={styles.mediaItemCaption}>{caption}</div>
      </div>
    </div>
  )
}

export default MediaItem
